import appFooter from './index.vue'

appFooter.install = function (Vue) {
  Vue.component(appFooter.name, appFooter)
}

export default appFooter
